import { defineMessages } from 'react-intl';

const languages = defineMessages({
  cs: {
    id: 'pages.shared.header.languages.cs',
    defaultMessage: '{langCode} - Český',
  },
  da: {
    id: 'pages.shared.header.languages.da',
    defaultMessage: '{langCode} - Dansk',
  },
  de: {
    id: 'pages.shared.header.languages.de',
    defaultMessage: '{langCode} - Deutsch',
  },
  en: {
    id: 'pages.shared.header.languages.en',
    defaultMessage: '{langCode} - English',
  },
  es: {
    id: 'pages.shared.header.languages.es',
    defaultMessage: '{langCode} - Español',
  },
  fi: {
    id: 'pages.shared.header.languages.fi',
    defaultMessage: '{langCode} - Suomi',
  },
  fr: {
    id: 'pages.shared.header.languages.fr',
    defaultMessage: '{langCode} - Français',
  },
  hi: {
    id: 'pages.shared.header.languages.hi',
    defaultMessage: '{langCode} - हिन्दी',
  },
  hu: {
    id: 'pages.shared.header.languages.hu',
    defaultMessage: '{langCode} - Magyar',
  },
  it: {
    id: 'pages.shared.header.languages.it',
    defaultMessage: '{langCode} - Italiano',
  },
  ja: {
    id: 'pages.shared.header.languages.ja',
    defaultMessage: '{langCode} - 日本語',
  },
  nl: {
    id: 'pages.shared.header.languages.nl',
    defaultMessage: '{langCode} - Nederlands',
  },
  no: {
    id: 'pages.shared.header.languages.no',
    defaultMessage: '{langCode} - Norsk',
  },
  pl: {
    id: 'pages.shared.header.languages.pl',
    defaultMessage: '{langCode} - Polski',
  },
  pt: {
    id: 'pages.shared.header.languages.pt',
    defaultMessage: '{langCode} - Português',
  },
  ro: {
    id: 'pages.shared.header.languages.ro',
    defaultMessage: '{langCode} - Română',
  },
  ru: {
    id: 'pages.shared.header.languages.ru',
    defaultMessage: '{langCode} - Русский',
  },
  sk: {
    id: 'pages.shared.header.languages.sk',
    defaultMessage: '{langCode} - Slovenských',
  },
  sv: {
    id: 'pages.shared.header.languages.sv',
    defaultMessage: '{langCode} - Svenska',
  },
  zh: {
    id: 'pages.shared.header.languages.zh',
    defaultMessage: '{langCode} - 简体中文',
  },
});

export default {
  pages: {
    shared: {
      header: {
        languages,
      },
    },
  },
};
